import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { GeneralDialog } from 'sharedComponents';
import LoadingStatusWrapper from 'sharedComponents/WithLoadingStatus/LoadingStatusWrapper';
import { apiCallStatus, popupTypes } from 'helpers/constants';
import ErrorView from 'sharedComponents/ErrorBoundary/ErrorView';
import { useReportIssue } from 'sharedHooks/useReportIssue';

import './style.scss';

const TrendCommentsDeleteModal = ({
    loadingStatus,
    errorData,
    deleteTrendCommentRequest,
    clearDeleteTrendCommentError,
    close,
    commentID,
    show,
}) => {
    const { t: translate } = useTranslation();
    const { showReportIssue } = useReportIssue();
    const [hideDeleteErrorView, setHideDeleteErrorView] = useState(false);

    useEffect(() => {
        if (show) {
            setHideDeleteErrorView(false);
        }
    }, [show]);

    const shouldShowDeleteError =
        !hideDeleteErrorView &&
        loadingStatus === apiCallStatus.ERROR &&
        errorData?.error;

    const handleRetry = () => {
        setHideDeleteErrorView(true);
        clearDeleteTrendCommentError();
    };

    return <GeneralDialog
        show={show}
        close={close}
        title={translate('ABB.Powertrain.Frontend.deleteCommentDialogTitle')}
        modalClassName='delete-comments-dialog'
        backdropClassName='delete-comments-backdrop'
        notificationType={popupTypes.INFO}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
        }}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.deleteLabel'),
            onClick: () => {
                deleteTrendCommentRequest(commentID, close);
            },
            disabled: loadingStatus === apiCallStatus.LOADING
        }}
        closeButton={true}
    >
        <Container fluid className={`delete-comment-container gx-0 ${shouldShowDeleteError ? 'has-error-view' : ''}`}>
            <LoadingStatusWrapper
                useCustomAnchor
                transparent
                loadingStatus={loadingStatus}>
                {shouldShowDeleteError ?
                    <ErrorView
                        errorCode={errorData?.errorCode}
                        onRetry={handleRetry}
                        onReportIssue={showReportIssue}
                    />
                    : <Row className='info-text-row gx-0'>
                        <Col>{translate('ABB.Powertrain.Frontend.deleteCommentDialogMessage')}</Col>
                    </Row>
                }
            </LoadingStatusWrapper>
        </Container>
    </GeneralDialog>;
};

TrendCommentsDeleteModal.propTypes = {
    loadingStatus: PropTypes.string,
    errorData: PropTypes.shape({
        loadingStatus: PropTypes.string,
        errorCode: PropTypes.number,
        error: PropTypes.object
    }),
    deleteTrendCommentRequest: PropTypes.func.isRequired,
    clearDeleteTrendCommentError: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    commentID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    show: PropTypes.bool.isRequired
};

export default TrendCommentsDeleteModal;
